import React from 'react';
import { motion } from 'framer-motion';
import { BookOpen, FileText, Globe2, TrendingUp, Truck, Shield } from 'lucide-react';

const modules = [
  {
    title: 'Module 1: Export Business Fundamentals',
    icon: BookOpen,
    topics: [
      'Introduction to international trade',
      'Export market research',
      'Product selection and validation',
      'Understanding export regulations'
    ]
  },
  {
    title: 'Module 2: Documentation & Compliance',
    icon: FileText,
    topics: [
      'Essential export documentation',
      'Customs procedures',
      'Quality standards and certifications',
      'Legal requirements'
    ]
  },
  {
    title: 'Module 3: Market Entry Strategies',
    icon: Globe2,
    topics: [
      'International market analysis',
      'Buyer identification',
      'Pricing strategies',
      'Negotiation techniques'
    ]
  },
  {
    title: 'Module 4: Financial Management',
    icon: TrendingUp,
    topics: [
      'Export financing options',
      'Payment methods',
      'Risk management',
      'Foreign exchange'
    ]
  },
  {
    title: 'Module 5: Logistics & Supply Chain',
    icon: Truck,
    topics: [
      'Transportation methods',
      'Packaging requirements',
      'Warehousing',
      'Supply chain optimization'
    ]
  },
  {
    title: 'Module 6: Risk Management',
    icon: Shield,
    topics: [
      'Trade risk assessment',
      'Insurance options',
      'Contract management',
      'Dispute resolution'
    ]
  }
];

const Zero2ExportCurriculum = () => {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <motion.h2
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="text-3xl font-bold text-gray-900 sm:text-4xl"
          >
            Program Curriculum
          </motion.h2>
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0.2 }}
            className="mt-4 text-xl text-gray-600"
          >
            A comprehensive curriculum designed to transform beginners into export professionals
          </motion.p>
        </div>

        <div className="grid gap-8 md:grid-cols-2 lg:grid-cols-3">
          {modules.map((module, index) => (
            <motion.div
              key={module.title}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.1 }}
              className="bg-white rounded-xl shadow-lg p-6 hover:shadow-xl transition-shadow duration-300"
            >
              <div className="w-12 h-12 bg-blue-100 rounded-lg flex items-center justify-center mb-6">
                <module.icon className="h-6 w-6 text-blue-600" />
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-4">{module.title}</h3>
              <ul className="space-y-3">
                {module.topics.map((topic, topicIndex) => (
                  <li key={topicIndex} className="flex items-center text-gray-600">
                    <div className="h-2 w-2 bg-blue-600 rounded-full mr-3" />
                    {topic}
                  </li>
                ))}
              </ul>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Zero2ExportCurriculum;